// Dependencies
import { createFileRoute } from "@tanstack/react-router";
import { PageShell, PageHero } from "@/components/PageShell";
import { CategoryProductGrid } from "@/components/CategoryProductGrid";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

// Images
import heroImage from "@/assets/hero-propulsion.png";
import arionImg from "@/assets/arion.png";
import rcsImg from "@/assets/rcs.png";
import atlasImg from "@/assets/otv.png";

export const Route = createFileRoute("/$lang/category/propulsion-systems")({
  head: () => ({
    meta: [
      { title: i18n.t("category/propulsion-systems:metaTitle", "Propulsion Systems — BIZU Space") },
      {
        name: "description",
        content: i18n.t("category/propulsion-systems:metaDesc",
          "Liquid propellant rocket engines, reaction control systems (RCS), and orbital transfer vehicle (OTV) stages developed in-house by BIZU Space.",
        ),
      },
      { property: "og:title", content: i18n.t("category/propulsion-systems:metaTitle", "Propulsion Systems — BIZU Space") },
      {
        property: "og:description",
        content: i18n.t("category/propulsion-systems:metaOgDesc",
          "Developing regeneratively cooled HTP liquid engines, modular attitude thrusters, and integrated upper stages.",
        ),
      },
      { property: "og:url", content: "/category/propulsion-systems" },
    ],
    links: [{ rel: "canonical", href: "https://bizu.space/category/propulsion-systems" }],
  }),
  component: PropulsionSystems,
});

function PropulsionSystems() {
  const { t } = useTranslation("category/propulsion-systems");

  const products = [
    {
      name: t("arionName", "ARION Liquid Rocket Engine"),
      link: "/products/arion-liquid-rocket-engine",
      image: arionImg,
      buttonText: t("arionBtn", "Explore"),
    },
    {
      name: t("rcsName", "Reaction Control System"),
      link: "/products/reaction-control-system",
      image: rcsImg,
      buttonText: t("rcsBtn", "Explore"),
    },
    {
      name: t("atlasName", "Upper Stage & OTV ATLAS-HTP"),
      link: "/products/atlas-htp",
      image: atlasImg,
      buttonText: t("atlasBtn", "Explore"),
    },
  ];

  return (
    <PageShell>
      {/* HERO SECTION */}
      <PageHero
        title={t("heroTitle", "Propulsion Systems")}
        description={t("heroDesc",
          "Advanced chemical propulsion systems engineered for space applications, including liquid rocket engines, reaction control systems, and upper stage propulsion solutions.",
        )}
        image={heroImage}
      />
      {/* TITLE SECTION */}
      <section className="pt-20">
        <div className="container-bizu">
          <h2 className="display text-4xl md:text-5xl text-center">
            {t("sectionTitle", "Vertical Integrated Propulsion Technologies")}
          </h2>
        </div>
      </section>
      {/* PRODUCTS SECTION */}
      <CategoryProductGrid products={products} />
    </PageShell>
  );
}
